enum ConvertDialogFields {
	PDFA_FORMAT = "pdfa-format",
	PDFA_RESOLUTION = "pdfa-resolution",
	LOSSLESS = "lossless",
	JPEG_QUALITY = "jpeg-quality",
	EMBED_FONTS = "embed-fonts",
	PAGE_FORMAT = "page-format",
	WIDTH = "width",
	HEIGHT = "height",
	ORIENTATION = "orientation",
	PREVIEW = "preview",
	MARGIN_TOP = "margin_top",
	MARGIN_BOTTOM = "margin_bottom",
	MARGIN_LEFT = "margin_left",
	MARGIN_RIGHT = "margin_right",
	PAGERANGE = "pagerange",
	RESOLUTION = "resolution",
	DPI = "dpi",
	PASSWORD = "password",
	HTML_PARSED = "html_parsed",
	HTML_USE_AS_TEMPLATE = "html_use_as_template",
	BASE_URL = "base_url",
	HTML_ADJUST_FONTS = "html_adjust_fonts",
	HTML_DOWNLOAD_IMAGES = "html_download_images",
	HTML_USE_BACKGROUND = "html_use_background",
	SYNTAX_DETECTION = "syntax_detection",
	LANGUAGE = "language",
	FONT_FAMILY = "font_family",
	WORD_BREAK = "word_break",
	LINE_HEIGHT = "line_height",
	FONT_SIZE = "font_size",
	LINE_NUMBERS = "line_numbers",
	FONT_COLOR = "font_color",
	XML_MODE = "xml_mode",
	XSLT_FILE = "xslt_file",
	XRECHNUNG_FILE = "xrechnung_file",
	XRECHNUNG_OVERWRITE = "xrechnung_overwrite",
	EMAIL_ATTACHMENT = "email_attachment",
	EMAIL_ADJUST_FONTS = "email_adjust_fonts",
	EMAIL_DOWNLOAD_IMAGES = "email_download_images",
	EMAIL_USE_BACKGROUND = "email_use_background",
	EMAIL_RESIZE_IMAGES = "email_resize_images",
	EMAIL_RESIZE_TABLES = "email_resize_tables",
	TEMPLATE_LANGUAGE = "template_language",
	UNIT = "unit",
	ASPECT_RATIO = "aspect_ratio",
	HEADER_PLAIN = "header_plain",
	HEADER_FONT_FAMILY = "header_font_family",
	HEADER_FONT_COLOR = "header_font_color",
	HEADER_FONT_SIZE = "header_font_size",
	HEADER_ALIGNMENT = "header_alignment",
	HEADER_CONTENT = "header_content",
	HEADER_MARGIN_TOP = "header_margin_top",
	HEADER_MARGIN_BOTTOM = "header_margin_bottom",
	HEADER_MARGIN_LEFT = "header_margin_left",
	HEADER_MARGIN_RIGHT = "header_margin_right",
	FOOTER_PLAIN = "footer_plain",
	FOOTER_FONT_FAMILY = "footer_font_family",
	FOOTER_FONT_COLOR = "footer_font_color",
	FOOTER_FONT_SIZE = "footer_font_size",
	FOOTER_ALIGNMENT = "footer_alignment",
	FOOTER_CONTENT = "footer_content",
	FOOTER_MARGIN_TOP = "footer_margin_top",
	FOOTER_MARGIN_BOTTOM = "footer_margin_bottom",
	FOOTER_MARGIN_LEFT = "footer_margin_left",
	FOOTER_MARGIN_RIGHT = "footer_margin_right",
	HTML_TEMPLATE_FILE = "html_template_file",
	HTML_TEMPLATE_USE_FILE = "html_template_use_file",
	HTML_TEMPLATE_CONTENT = "html_template_content",
	HTML_ERROR_REPORT = "html_error_report",
	HTML_ERROR_REPORT_FORMAT = "html_error_report_format",
	CONVERTER = "CONVERTER"
}

export default ConvertDialogFields;